import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../../Css/Sidebar/sidebar.css'; 

const EmpleadoSidebar: React.FC = () => {
    // Estado solo para hover - siempre contraído por defecto
    const [isHovered, setIsHovered] = useState(false);

    // Obtener datos del empleado loggeado
    const nombreEmpleado = localStorage.getItem('nombreEmpleado') || 'Empleado';
    const cveEmpleado = localStorage.getItem('cveEmpleado') || '';

    // Efecto para actualizar CSS variables y clases del body cuando cambie el estado
    useEffect(() => {
        const sidebarWidth = isHovered ? '250px' : '60px';
        document.documentElement.style.setProperty('--sidebar-width', sidebarWidth);
        
        // Agregar clase al body para controlar el layout
        if (isHovered) {
            document.body.classList.add('sidebar-expanded');
            document.body.classList.remove('sidebar-collapsed');
        } else {
            document.body.classList.add('sidebar-collapsed');
            document.body.classList.remove('sidebar-expanded');
        }
    }, [isHovered]);

    // Efecto inicial para establecer el estado contraído
    useEffect(() => {
        document.documentElement.style.setProperty('--sidebar-width', '60px');
        document.body.classList.add('sidebar-collapsed');
        
        // Cleanup al desmontar el componente
        return () => {
            document.body.classList.remove('sidebar-collapsed', 'sidebar-expanded');
        };
    }, []);

    return (
        <>
            {/* Estilos CSS inline para asegurar que funcionen */}
            <style>
                {`
                    :root {
                        --sidebar-width: 60px;
                    }
                    
                    body.sidebar-collapsed .content-wrapper,
                    body.sidebar-collapsed .main-content,
                    body.sidebar-collapsed .wrapper {
                        margin-left: 60px !important;
                        width: calc(100% - 60px) !important;
                        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                    }
                    
                    body.sidebar-expanded .content-wrapper,
                    body.sidebar-expanded .main-content,
                    body.sidebar-expanded .wrapper {
                        margin-left: 250px !important;
                        width: calc(100% - 250px) !important;
                        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                    }
                    
                    .content-wrapper,
                    .main-content,
                    .wrapper {
                        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                        margin-left: var(--sidebar-width) !important;
                        width: calc(100% - var(--sidebar-width)) !important;
                        min-height: 100vh;
                        position: relative;
                    }
                    
                    /* Asegurar que no haya scroll horizontal */
                    body {
                        overflow-x: hidden !important;
                    }
                    
                    /* Para elementos con position fixed como headers */
                    .main-header,
                    .navbar {
                        margin-left: var(--sidebar-width) !important;
                        width: calc(100% - var(--sidebar-width)) !important;
                        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                    }
                    
                    /* Responsividad para móviles */
                    @media (max-width: 768px) {
                        body.sidebar-collapsed .content-wrapper,
                        body.sidebar-collapsed .main-content,
                        body.sidebar-collapsed .wrapper,
                        body.sidebar-expanded .content-wrapper,
                        body.sidebar-expanded .main-content,
                        body.sidebar-expanded .wrapper {
                            margin-left: 0 !important;
                            width: 100% !important;
                        }
                        
                        .main-sidebar {
                            transform: translateX(-100%);
                            z-index: 9999;
                        }
                        
                        .main-sidebar:hover {
                            transform: translateX(0);
                        }
                    }
                `}
            </style>

            <aside 
                className="main-sidebar sidebar-dark-primary elevation-4" 
                style={{
                    position: 'fixed',
                    height: '100vh',
                    overflowY: 'auto',
                    width: isHovered ? '250px' : '60px',
                    zIndex: 1000,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 50%, #1d4ed8 100%)',
                    boxShadow: '4px 0 20px rgba(0, 0, 0, 0.15)',
                    borderRight: '1px solid rgba(255, 255, 255, 0.1)',
                    left: 0,
                    top: 0
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {/* Brand Logo */}
                <Link 
                    to="/empinicio" 
                    className="brand-link"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: !isHovered ? '0.75rem' : '0.8125rem 0.5rem',
                        fontSize: '1.1rem',
                        fontWeight: '300',
                        color: 'rgba(255, 255, 255, 0.8)',
                        textDecoration: 'none',
                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                        transition: 'all 0.3s ease',
                        justifyContent: !isHovered ? 'center' : 'flex-start',
                        background: 'rgba(255, 255, 255, 0.05)',
                        backdropFilter: 'blur(10px)'
                    }}
                >
                    <img
                        src="dist/img/bbtt2.png"
                        alt="Babatsa Logo"
                        className="brand-image img-circle elevation-3"
                        style={{ 
                            opacity: 0.8,
                            width: '33px',
                            height: '33px',
                            transition: 'all 0.3s ease',
                            border: '2px solid rgba(255, 255, 255, 0.2)',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                        }}
                    />
                    <span 
                        className="brand-text font-weight-light"
                        style={{
                            opacity: !isHovered ? 0 : 1,
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            marginLeft: !isHovered ? '0' : '10px',
                            display: !isHovered ? 'none' : 'inline',
                            whiteSpace: 'nowrap',
                            fontWeight: '600',
                            textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        Babatsa
                    </span>
                </Link>

                {/* Sidebar */}
                <div className="sidebar" style={{ 
                    padding: !isHovered ? '0.5rem 0' : '1rem',
                    transition: 'all 0.3s ease'
                }}>
                 
                    

                    {/* Sidebar Menu */}
                    <nav className="mt-2">
                        <ul
                            className="nav nav-pills nav-sidebar flex-column"
                            data-widget="treeview"
                            role="menu"
                            data-accordion="false"
                            style={{
                                paddingLeft: '0',
                                marginBottom: '0'
                            }}
                        >
                            {/* Inicio */}
                            <li className="nav-item" style={{ marginBottom: '4px' }}>
                                <Link 
                                    to="/empinicio" 
                                    className="nav-link"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: !isHovered ? '12px 0' : '12px 16px',
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease',
                                        justifyContent: !isHovered ? 'center' : 'flex-start',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                        e.currentTarget.style.color = 'white';
                                        e.currentTarget.style.transform = 'translateX(4px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'transparent';
                                        e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                                        e.currentTarget.style.transform = 'translateX(0)';
                                    }}
                                >
                                    <i 
                                        className="fas fa-home nav-icon"
                                        style={{
                                            fontSize: '16px',
                                            width: '20px',
                                            textAlign: 'center',
                                            transition: 'all 0.3s ease'
                                        }}
                                    ></i>
                                    <p style={{
                                        margin: '0',
                                        marginLeft: !isHovered ? '0' : '12px',
                                        opacity: !isHovered ? 0 : 1,
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        display: !isHovered ? 'none' : 'block',
                                        whiteSpace: 'nowrap',
                                        fontWeight: '500'
                                    }}>
                                        Inicio
                                    </p>
                                </Link>
                            </li>

                            {/* Peticiones */}
                            <li className="nav-item" style={{ marginBottom: '4px' }}>
                                <Link 
                                    to="/peticiones" 
                                    className="nav-link"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: !isHovered ? '12px 0' : '12px 16px',
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease',
                                        justifyContent: !isHovered ? 'center' : 'flex-start',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                        e.currentTarget.style.color = 'white';
                                        e.currentTarget.style.transform = 'translateX(4px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'transparent';
                                        e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                                        e.currentTarget.style.transform = 'translateX(0)';
                                    }}
                                >
                                    <i 
                                        className="fas fa-clipboard-list nav-icon"
                                        style={{
                                            fontSize: '16px',
                                            width: '20px',
                                            textAlign: 'center',
                                            transition: 'all 0.3s ease'
                                        }}
                                    ></i>
                                    <p style={{
                                        margin: '0',
                                        marginLeft: !isHovered ? '0' : '12px',
                                        opacity: !isHovered ? 0 : 1,
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        display: !isHovered ? 'none' : 'block',
                                        whiteSpace: 'nowrap',
                                        fontWeight: '500'
                                    }}>
                                        Nueva Petición
                                    </p>
                                </Link>
                            </li>

                           

                            {/* Separador */}
                            <li 
                                className="nav-header"
                                style={{
                                    opacity: !isHovered ? 0 : 1,
                                    transition: 'all 0.3s ease',
                                    display: !isHovered ? 'none' : 'block',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    margin: '20px 0 10px 0',
                                    padding: '0 16px'
                                }}
                            >
                                SESIÓN
                            </li>

                            {/* Cerrar Sesión */}
                            <li className="nav-item" style={{ marginBottom: '4px' }}>
                                <Link 
                                    to="/login-empleados" 
                                    className="nav-link"
                                    onClick={() => {
                                        localStorage.removeItem('authToken2');
                                        localStorage.removeItem('cveEmpleado');
                                        localStorage.removeItem('nombreEmpleado');
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: !isHovered ? '12px 0' : '12px 16px',
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease',
                                        justifyContent: !isHovered ? 'center' : 'flex-start',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'rgba(220, 53, 69, 0.2)';
                                        e.currentTarget.style.color = '#ff6b6b';
                                        e.currentTarget.style.transform = 'translateX(4px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'transparent';
                                        e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                                        e.currentTarget.style.transform = 'translateX(0)';
                                    }}
                                >
                                    <i 
                                        className="fas fa-sign-out-alt nav-icon"
                                        style={{
                                            fontSize: '16px',
                                            width: '20px',
                                            textAlign: 'center',
                                            transition: 'all 0.3s ease'
                                        }}
                                    ></i>
                                    <p style={{
                                        margin: '0',
                                        marginLeft: !isHovered ? '0' : '12px',
                                        opacity: !isHovered ? 0 : 1,
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        display: !isHovered ? 'none' : 'block',
                                        whiteSpace: 'nowrap',
                                        fontWeight: '500'
                                    }}>
                                        Cerrar Sesión
                                    </p>
                                </Link>
                            </li>
                        </ul>
                    </nav>

                    {/* Portal Info Panel */}
                    <div className="portal-panel mt-3 pb-3 mb-3 d-flex" style={{
                        overflow: 'hidden',
                        transition: 'all 0.3s ease',
                        background: 'rgba(59, 130, 246, 0.1)',
                        borderRadius: '12px',
                        padding: !isHovered ? '0.8rem 0' : '1rem',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        backdropFilter: 'blur(10px)',
                        justifyContent: !isHovered ? 'center' : 'flex-start',
                        alignItems: 'center',
                        minHeight: !isHovered ? '50px' : 'auto',
                        width: '100%',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)'
                    }}>
                        <div className="portal-icon" style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: !isHovered ? '100%' : 'auto',
                            margin: !isHovered ? '0' : '0'
                        }}>
                            <i 
                                className="fas fa-robot"
                                style={{
                                    transition: 'all 0.3s ease',
                                    fontSize: '24px',
                                    color: '#3b82f6',
                                    textShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                                    flexShrink: 0,
                                    display: 'block'
                                }}
                            />
                        </div>
                        
                        <div
                            className="portal-info"
                            style={{
                                opacity: !isHovered ? 0 : 1,
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                marginLeft: !isHovered ? '0' : '12px',
                                display: !isHovered ? 'none' : 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                width: !isHovered ? '0' : 'auto',
                                overflow: 'hidden'
                            }}
                        >
                            <span
                                style={{
                                    color: 'white',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    fontSize: '0.9rem',
                                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                🌐 Portal de BbtSIS
                            </span>
                            <small style={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontSize: '0.75rem',
                                marginTop: '2px'
                            }}>
                                🤖 Connor v2.0
                            </small>
                        </div>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default EmpleadoSidebar;